import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { formatPrice, formatURL } from '../../../utils';
import { clearCoupon, cleanErrors, cleanStatesPurchaseMobile } from '../../../actions/purchaseActions';

class BoxValues extends Component {
  backSearch = (e) => {
    const location = {
      pathname: formatURL(
        this.props.match,
        `/pesquisa/${this.props.match.params.destination}/${this.props.match.params.begin_date}/${this.props.match.params.end_date}/`,
        null
      ),
    };
    this.props.cleanStatesPurchaseMobile();
    this.props.cleanErrors();
    this.props.history.push(location);
  };

  renderPrice = () => {
    const plan = this.props.plan[0];

    if (this.props.purchaseSummary.coupon_discount && !this.props.purchaseSummary.total) return formatPrice('0,00');
    else if (this.props.purchaseSummary.total) return formatPrice(this.props.purchaseSummary.total);
    else return formatPrice(plan.adult.price);
  };

  render() {
    if (!this.props.plan[0]) return <div />;

    const plan = this.props.plan[0];

    return (
      <div className="box box-values">
        <h4 className="desktop">Resumo da compra</h4>
        <ul className="lista-passageiros">
          {this.props.purchaseSummary.elder.qte > 0 && (
            <li className="flex">
              <span>
                {this.props.purchaseSummary.elder.qte} Adulto{this.props.purchaseSummary.elder.qte > 1 ? 's' : ''}{' '}
                (maior de {plan.adult.max_age} anos)
              </span>
              <span>R$ {formatPrice(this.props.purchaseSummary.elder.price)}</span>
            </li>
          )}
          {this.props.purchaseSummary.adult.qte > 0 && (
            <li className="flex">
              <span>
                {this.props.purchaseSummary.adult.qte} Adulto{this.props.purchaseSummary.adult.qte > 1 ? 's' : ''}
              </span>
              <span>R$ {formatPrice(this.props.purchaseSummary.adult.price)}</span>
            </li>
          )}
          {this.props.purchaseSummary.child.qte > 0 && (
            <li className="flex">
              <span>
                {this.props.purchaseSummary.child.qte} Criança{this.props.purchaseSummary.child.qte > 1 ? 's' : ''} (até{' '}
                {plan.child.max_age} anos)
              </span>
              <span>R$ {formatPrice(this.props.purchaseSummary.child.price)}</span>
            </li>
          )}
          {this.props.purchaseSummary.invalid.qte > 0 && (
            <React.Fragment>
              <li className="flex">
                <span>
                  {this.props.purchaseSummary.invalid.qte} Adulto{this.props.purchaseSummary.invalid.qte > 1 ? 's' : ''}{' '}
                  (idade incompatível com o plano)
                </span>
              </li>
              <li className="flex back-search">
                <span onClick={this.backSearch}>
                  <u>Voltar à pesquisa</u>
                </span>
              </li>
            </React.Fragment>
          )}
        </ul>
        <ul className="lista-subtotal">
          <li className="flex">
            <span className="title-subtotal">Subtotal</span>
            <span>R$ {formatPrice(this.props.purchaseSummary.subtotal || plan.adult.price)}</span>
          </li>

          {this.props.purchaseSummary.paymentMethodDiscountValue > 0 && (
            <li className="flex">
              <span>Desconto {this.props.purchaseSummary.paymentMethodSelected}</span>
              <span>- R$ {formatPrice(this.props.purchaseSummary.paymentMethodDiscountValue)}</span>
            </li>
          )}

          {this.props.purchaseSummary.coupon_discount > 0 && (
            <li className="flex coupon">
              <span>Cupom aplicado</span>
              <span>- R$ {formatPrice(this.props.purchaseSummary.coupon_discount)}</span>
            </li>
          )}

          {this.props.purchaseSummary.creditCouponAmountUsed > 0 && (
            <li className="flex credit-coupon-applied">
              <span>Créditos utilizados</span>
              <span>- R$ {formatPrice(this.props.purchaseSummary.creditCouponAmountUsed)}</span>
            </li>
          )}

          <li className="flex">
            <span className="text-total">Total</span>
            <span className="text-total">R$ {this.renderPrice()}</span>
          </li>
        </ul>
      </div>
    );
  }
}

export default withRouter(
  connect(
    (state) => ({
      plan: state.search.plans,
      purchaseSummary: state.purchase.purchaseSummary,
      mobile: state.mobile.mobileActive,
    }),
    {
      clearCoupon,
      cleanStatesPurchaseMobile,
      cleanErrors,
    }
  )(BoxValues)
);



// WEBPACK FOOTER //
// ./src/components/purchase/purchase_description/BoxValues.jsx